import React, { useEffect, useState } from "react";
import { GoogleMap, HeatmapLayer } from "@react-google-maps/api";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";

const containerStyle = {
  width: "100%",
  height: "17rem",
};



const AppHeatMapComponent = () => {
  //const [map, setMap] = useState<google.maps.Map | null>(null);
  const [heatmapData, setHeatmapData] = useState<google.maps.LatLng[]>([]);
  const [center, setCenter] = useState<{ lat: number; lng: number } | undefined>(undefined);

  useEffect(() => {
    ZyppLiteApi.api.googleMapsOnDutyRiders().then((response) => {
      const vehicles = response.data.vehicles || [];
  
      const points = vehicles
        .filter((e:any) => e.latitude && e.longitude)
        .map((e:any) => {
          const lat = parseFloat(e.latitude.toString());
          const lng = parseFloat(e.longitude.toString());
          return new window.google.maps.LatLng(lat, lng);
        });
  
      setHeatmapData(points);
  
      if (points.length > 0) {
        setCenter({
          lat: points[0].lat(),
          lng: points[0].lng(),
        });
      }
    });
  }, []);
  

  //const onLoad = (mapInstance: google.maps.Map) => setMap(mapInstance);
 // const onUnmount = () => setMap(null);
 
  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      zoom={9}
      center={center || { lat: 28.6139, lng: 77.2090 }} // fallback center (Delhi)
      options={{ fullscreenControl: true, zoomControl: true }}
     // onLoad={onLoad}
      //onUnmount={onUnmount}
      // 🧠 Make sure to pass this prop if you're using LoadScript elsewhere
      // libraries={libraries} <- only needed in LoadScript
    >
      {heatmapData.length > 0 && (
        <HeatmapLayer
          data={heatmapData}
          options={{
            radius: 30,
            opacity: 0.6,
          }}
        />
      )}
    </GoogleMap>
  );
};

export const AppHeatMap = React.memo(AppHeatMapComponent);
